var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Dropdown, MenuItem, FormLabel, FormController, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { isUserAllowedToViewAllPurchases } from '../../../utils/policy-utils';
/**
 *
 * @returns Purchaser Select Dropdown Element
 */
export var PurchaserSelect = function (_a) {
    var customerRole = _a.customerRole, customerType = _a.customerType;
    var username = useThdCustomer().username;
    var _b = usePurchaseHistoryContext(), pHRequest = _b.pHRequest, setPHRequest = _b.setPHRequest;
    var permissionCheck = isUserAllowedToViewAllPurchases(customerRole, customerType);
    var PurchaserItems = {
        allOrders: 'Everyone',
        myOrders: "".concat(username !== null && username !== void 0 ? username : '', " (Just Me)"),
    };
    if (customerType === 'b2b' && permissionCheck) {
        return (React.createElement(FormController, { fullWidth: true, "data-testid": "purchaser-select-dropdown" },
            React.createElement(FormLabel, null, "View Purchases Made By"),
            React.createElement(Dropdown, { style: { width: '214px' }, label: "View Purchases Made By", value: pHRequest.resultsFilter, onChange: function (event) {
                    setPHRequest(function (prevState) {
                        return __assign(__assign({}, prevState), { resultsFilter: event.target.value });
                    });
                } }, Object.keys(PurchaserItems).map(function (key) {
                return (React.createElement(MenuItem, { key: key, value: key }, PurchaserItems[key]));
            }))));
    }
    return null;
};
